import { render, staticRenderFns } from "./Studentscomment.vue?vue&type=template&id=012546b7&scoped=true&"
import script from "./Studentscomment.vue?vue&type=script&lang=js&"
export * from "./Studentscomment.vue?vue&type=script&lang=js&"
import style0 from "./Studentscomment.vue?vue&type=style&index=0&id=012546b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012546b7",
  null
  
)

export default component.exports